import React, { useEffect, useState, useContext } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Card,
  CardHeader,
  Grid,
} from "@mui/material";
import AccountingApi from "../../../Classes/API/AccountingApi";
import DataTable from "examples/Tables/DataTable";
import Pagination from "@mui/material/Pagination";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { useNavigate } from "react-router-dom";
import PatientSelector from "CinicComponents/PatientSelector";
import SearchStringOrIntReq from "../../../Classes/Models/Requests/SearchStringOrIntReq";
import Swal from "sweetalert2";
import { LanguageContext } from "App";
import AppointmentsApi from "../../../Classes/API/Appointments/AppointmentsApi";
import MDButton from "components/MDButton";
import SessionSelector from "CinicComponents/SessionSelector";
import TherapistSelector from "CinicComponents/TherapistSelector";
import CreatePatientProgramReq from "../../../Classes/Models/Requests/Appointments/CreatePatientProgram";
import { ExpandMore } from "@mui/icons-material";
import "./create-patient-style.scss";
const index = () => {
  const { translations, switchLanguage } = useContext(LanguageContext);
  let navigate = useNavigate();
  const [Patient, setPatient] = useState(null);
  const [Sessions, setSessions] = useState([]);
  const [SelectedSession, setSelectedSession] = useState();
  const [SelectedDay, setSelectedDay] = useState(0);
  const [SelectedHour, setSelectedHour] = useState(null);
  const [SelectedTherapist, setSelectedTherapist] = useState();
  const [ProgramEntries, setProgramEntries] = useState([]);

  const Days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  const getUnqiqueSessionsAndCount = (sessions) => {
    let uniqueSessions = [];
    sessions?.forEach((session) => {
      if (!uniqueSessions.includes(session.sessionName)) {
        uniqueSessions.push(session.sessionName);
      }
    });

    let finalArray = [];
    uniqueSessions?.forEach((sessionName) => {
      let count = sessions.filter((x) => x.sessionName == sessionName).length;
      finalArray.push({ Name: sessionName, Count: count });
    });

    return finalArray;
  };

  const GetPatientSessions = async () => {
    let req = new SearchStringOrIntReq();
    req.SearchInt = Patient.id;
    let res = await AppointmentsApi.GetPatientSuggestions(req);
    console.log(res);
    if (res.status == "Success") {
      setSessions(res.data.list[0].getAccountingSessions);
    } else {
      Swal.fire("Failed", res.message, "error");
    }
  };

  useEffect(() => {
    if (Patient) {
      GetPatientSessions();
    }
    return;
  }, [Patient]);

  const MakeTableRow = (dayIndex) => {
    let enteries = ProgramEntries.filter((x) => x.day == dayIndex);

    return (
      <Accordion key={dayIndex}>
        <AccordionSummary expandIcon={<ExpandMore />} id={`day-${dayIndex}`} className="day-card">
          <MDTypography variant="h6" fontWeight="medium">
            {Days[dayIndex]}
          </MDTypography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={2}>
            {[...Array(24).keys()].map((hour) => {
              let entry = enteries.find((e) => e.hour === hour);
              console.log(SelectedHour);
              return (
                <Grid item xs={6} sm={3} key={hour}>
                  {entry ? (
                    <>
                      <MDTypography variant="h6" fontWeight="regular" color="text">
                        {entry.session.name}
                      </MDTypography>
                      <MDTypography variant="body2" fontWeight="regular" color="text">
                        {entry.therapist.name}
                      </MDTypography>
                    </>
                  ) : (
                    <button
                      className={`time-selector btn btn-dark ${
                        SelectedDay === dayIndex && SelectedHour === hour ? "active" : ""
                      }`}
                      style={{
                        width: "100%",
                        height: "100%",
                      }}
                      onClick={() => {
                        setSelectedDay(dayIndex);
                        setSelectedHour(hour);
                      }}
                    >
                      {hour}:00
                    </button>
                  )}
                </Grid>
              );
            })}
          </Grid>
        </AccordionDetails>
      </Accordion>
    );
  };

  const MakeTable = () => {
    return Days.map((_, dayIndex) => MakeTableRow(dayIndex));
  };

  const AddEntry = () => {
    if (!SelectedSession) {
      Swal.fire("Failed", "Please Select Session", "error");
      return;
    }
    if (!SelectedTherapist) {
      Swal.fire("Failed", "Please Select Therapist", "error");
      return;
    }

    if (ProgramEntries.filter((x) => x.day == SelectedDay && x.hour == SelectedHour).length > 0) {
      Swal.fire("Failed", "This Time Slot is Already Taken", "error");
      return;
    }

    let entry = {
      day: SelectedDay,
      hour: SelectedHour,
      session: SelectedSession,
      therapist: SelectedTherapist,
    };
    let newProgramEntries = [...ProgramEntries];
    newProgramEntries.push(entry);
    setProgramEntries(newProgramEntries);
  };

  const savePatientProgram = async () => {
    console.log(Patient);
    Swal.fire({
      icon: "info",
      title: "Loading",
      text: "Please Wait",
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    if (ProgramEntries.length == 0) {
      Swal.fire("Failed", "Please Add At Least One Entry", "error");
      return;
    }

    let req = new CreatePatientProgramReq();

    req.PatientId = Patient.getPatient.id;
    // req.ProgramEntries = ProgramEntries;
    let entries = [];
    for (let i = 0; i < ProgramEntries.length; i++) {
      let entry = {
        DayIndex: ProgramEntries[i].day,
        HourIndex: ProgramEntries[i].hour,
        SessionId: ProgramEntries[i].session.id,
        TherapistId: ProgramEntries[i].therapist.getTherapist.id,
      };
      entries.push(entry);
    }
    req.ProgramEntries = entries;
    let res = await AppointmentsApi.CreatePatientProgram(req);
    if (res.status == "Success") {
      Swal.fire("Success", "Patient Program Created Successfully", "success");
    } else {
      Swal.fire("Failed", res.message, "error");
    }
  };
  console.log({
    checkPatient: !Patient?.getPatient,
  });
  console.log({
    checkSession: !SelectedSession,
  });
  console.log({
    checkTherapist: !SelectedTherapist,
  });
  console.log({
    checkLength: !ProgramEntries.length,
  });
  console.log({
    checkHour: !SelectedHour,
  });
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Card sx={{ marginTop: "2em" }}>
        <CardHeader title={translations.appintmentCreateNewPatientProgram} />

        <div className="patient-select-session">
          <div>
            <PatientSelector Patient={Patient} setPatient={setPatient} />
          </div>
          {/* show patient.user.name */}
          {/* <div className='selected-item'>
                        {
                            Patient ?
                                <MDTypography variant="h6" sx={{ marginTop: "1em" }}>Selected: {Patient.name}</MDTypography> :
                                <MDTypography variant="h6" sx={{ marginTop: "1em" }}>No Patient Selected</MDTypography>
                        }

                    </div> */}
          <div className="session-overview">
            <MDTypography variant="button" color="text" fontWeight="medium">
              {translations.appintmentCreateNewPatientProgramTotalSessions} {Sessions.length} &nbsp;
              <div className="session-count">
                {getUnqiqueSessionsAndCount(Sessions)
                  .sort((a, b) => a.Count - b.Count)
                  .map((session, index) => {
                    return (
                      <span>
                        {session.Name} : {session.Count}
                      </span>
                    );
                  })}
              </div>
            </MDTypography>
          </div>
        </div>
        <hr></hr>
        <div className="patient-card">
          <div className="col-md-6 patient-select">
            <div>
              <SessionSelector Patient={Patient} setSession={setSelectedSession} />
            </div>
            <div className="therapist-selector">
              <TherapistSelector setTherapist={setSelectedTherapist} />
            </div>
          </div>

          <div className="col-md-6 patient-select ">
            <MDTypography variant="h6" fontWeight="medium" color="text" sx={{}}>
              {translations.appintmentCreateNewPatientProgramSelectedHour}: {SelectedHour}:00
            </MDTypography>
            <MDTypography variant="h6" fontWeight="medium" color="text" sx={{}}>
              {translations.appintmentCreateNewPatientProgramSelectedDay}: {Days[SelectedDay]}
            </MDTypography>
            <MDTypography variant="h6" fontWeight="medium" color="text" sx={{}}>
              {translations.appintmentCreateNewPatientProgramSelectedSession}:{" "}
              {SelectedSession?.name}
            </MDTypography>
            <MDTypography variant="h6" fontWeight="medium" color="text" sx={{}}>
              {translations.appintmentCreateNewPatientProgramSelectedTherapist}:{" "}
              {SelectedTherapist?.name}
            </MDTypography>
          </div>
        </div>
        <div className="grid-full-width">
          <MDButton
            sx={{ backgroundColor: "#3560AD", "&:hover": { backgroundColor: "#4682B4" } }}
            m={2}
            color="primary"
            onClick={() => {
              AddEntry();
            }}
            disabled={
              !Patient?.getPatient || !SelectedSession || !SelectedTherapist || SelectedHour == null
            }
          >
            {translations.appintmentCreateNewPatientProgramAddEntry}
          </MDButton>

          <MDButton
            sx={{ backgroundColor: "#3560AD", "&:hover": { backgroundColor: "#4682B4" } }}
            color="success"
            onClick={() => {
              savePatientProgram();
            }}
            disabled={
              !Patient?.getPatient ||
              !SelectedSession ||
              !SelectedTherapist ||
              ProgramEntries.length == 0
            }
          >
            {translations.appintmentCreateNewPatientProgramSaveProgram}
          </MDButton>
        </div>
        <hr />
        <div className="accordion-container">{MakeTable()}</div>
      </Card>
    </DashboardLayout>
  );
};

export default index;
